import { DropdownOptionModel } from "../view/components/shared/dropdown/models";

interface OptionalParams {
  labelKey?: string;
  valueKey?: string;
  disabledKey?: string;
  additionalLabelKey?: string,
  additionalStaticLabel?: string,
  translate?: (key: string) => string;
}

export const dataToDropDownConverter = (data: Array<Record<string, any>>, options?: OptionalParams): Array<DropdownOptionModel> => {
  const labelKey = options?.labelKey || "label";
  const valueKey = options?.valueKey || "value";
  const disabledKey = options?.disabledKey || "disabled";
  const additionalLabelKey = options?.additionalLabelKey || "additionalLabel";

  const translate = options?.translate;

  return data.map((data) => ({
    ...data,
    value: data[valueKey],
    disabled: !!data[disabledKey],
    additionalLabel: data[additionalLabelKey],
    label: translate ? translate(data[labelKey]) : data[labelKey],
  }));
};
